import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import PageTitle from '../../../layouts/PageTitle';

const ParametersDashboard = () => {
    const { t } = useTranslation();

    return (
        <>
            <PageTitle activeMenu="Parâmetros da Empresa" motherMenu="Super Admin" />

            <Row>
                <Col xl={12}>
                    <Card>
                        <Card.Header>
                            <Card.Title>Gerenciamento de Parâmetros (Em Breve)</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <p>Esta tela permitirá ao Super Admin configurar parâmetros globais ou específicos de cada tenant (empresa).</p>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    );
};

export default ParametersDashboard;
